<template>
    <div v-if="currentRoute.name">
        <router-link
            class="button-secondary shadow-none text-primary-dark space-x-3 text-[1.1rem] px-5 py-2 lg:px-3.5 lg:text-base lg:h-9 w-full whitespace-nowrap border-primary-dark"
            :to="isInstitutionMap
                ? getRouteLocation(currentRoute.params.section, {
                    query: currentRoute.query,
                })
                : getRouteLocation('InstitutionMap', {
                    query: currentRoute.query,
                    params: {
                        section: currentRoute.name,
                    },
                })
            "
        >
            <svg
                v-if="isInstitutionMap"
                class="fill-current w-[18px]"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 122.88 112.5"
                style="enable-background:new 0 0 122.88 112.5"
                xml:space="preserve"
            ><g><path style="fill-rule:evenodd;clip-rule:evenodd;" d="M12.56,87.39c6.93,0,12.56,5.62,12.56,12.56c0,6.93-5.62,12.56-12.56,12.56C5.62,112.5,0,106.88,0,99.95 C0,93.01,5.62,87.39,12.56,87.39L12.56,87.39z M35.07,88.24h86.38c0.79,0,1.43,0.64,1.43,1.43v19.93c0,0.79-0.64,1.43-1.43,1.43 H35.07c-0.79,0-1.43-0.64-1.43-1.43V89.67C33.64,88.88,34.29,88.24,35.07,88.24L35.07,88.24z M35.07,44.7h86.38 c0.79,0,1.43,0.64,1.43,1.43v19.93c0,0.79-0.64,1.43-1.43,1.43H35.07c-0.79,0-1.43-0.64-1.43-1.43V46.13 C33.64,45.34,34.29,44.7,35.07,44.7L35.07,44.7z M35.07,1.16h86.38c0.79,0,1.43,0.64,1.43,1.43v19.93c0,0.79-0.64,1.43-1.43,1.43 H35.07c-0.79,0-1.43-0.64-1.43-1.43V2.59C33.64,1.8,34.29,1.16,35.07,1.16L35.07,1.16z M12.56,43.69c6.93,0,12.56,5.62,12.56,12.56 c0,6.93-5.62,12.56-12.56,12.56C5.62,68.81,0,63.19,0,56.25C0,49.32,5.62,43.69,12.56,43.69L12.56,43.69z M12.56,0 c6.93,0,12.56,5.62,12.56,12.56c0,6.93-5.62,12.56-12.56,12.56C5.62,25.11,0,19.49,0,12.56C0,5.62,5.62,0,12.56,0L12.56,0z" /></g></svg>

            <svg
                v-else
                class="fill-current w-[26px]"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 40 40"
            >
                <path d="M27.74,4.69l-9.07,5.4L10.19,7.68,0,11.81v23.5L10.2,31.1l9.7,2.76,8.57-5.55L40,31.39V7.9Zm-18,22.57L3.48,29.65v-15l6.25-2.39Zm9.51,1.95L10.48,27V12l8.76,2.61Zm.75.44V14.42l8-5.26V24.53ZM36.5,26.39l-7.76-2.17v-15l7.76,2.16Z" />
            </svg>

            <span v-if="isInstitutionMap">
                {{ $t('booking.ViewList') }}
            </span>
            <span v-else>
                {{ $t('booking.ViewInMap') }}
            </span>
        </router-link>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { getRouteLocation } from '@/js/booking/booking-search-router'

    const currentRoute = useRoute()
    const isInstitutionMap = computed(() => currentRoute.name == 'InstitutionMap')

</script>
